// stores
import { REPUBS } from '@cx-modules/constants';

import store from '~/components/betslip/betslip.store';

export enum oddsFormatsEnum {
	DECIMAL,
	AMERICAN,
	FRACTIONAL,
}

export interface IConfig {
	betting: boolean;
	canChangeOddsFormat?: boolean;
	login: boolean;
	oddsFormat: oddsFormatsEnum;
	offers: boolean;
	search: boolean;
}

class ConfigurationManager {
	private static instance: ConfigurationManager;

	private config: IConfig;

	public constructor(config: IConfig) {
		this.config = config;
	}

	static getInstance(): ConfigurationManager {
		if (!ConfigurationManager.instance) {
			const repubConfig: Map<string, IConfig> = new Map([
				[
					REPUBS.US.name,
					{
						betting: true,
						offers: true,
						login: true,
						search: true,
						canChangeOddsFormat: true,
						oddsFormat: oddsFormatsEnum.AMERICAN,
					},
				],
				[
					REPUBS.XX.name,
					{
						betting: true,
						offers: true,
						login: true,
						search: true,
						canChangeOddsFormat: true,
						oddsFormat: oddsFormatsEnum.DECIMAL,
					},
				],
			]);

			const currentRepub = store.getState().client.config.repub;
			ConfigurationManager.instance = new ConfigurationManager(
				repubConfig.get(currentRepub) || repubConfig.get(REPUBS.XX.name)!,
			);
			// ... any one time initialization goes here ...
		}

		return ConfigurationManager.instance;
	}

	public getConfig(): IConfig {
		return this.config;
	}
}

export default ConfigurationManager;
